import React from 'react';
import { Box, styled } from '@mui/material';
import { AboComponent } from './abo-component/abo-component';
import { CentralNavigationBar } from './central-navigation-bar';

const SubBarWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isListPage'
})(({ theme, isListPage }) => ({
  position: "fixed",
  top: "84px",
  left: 0,
  right: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  background: "white",
  zIndex: 7,
  padding: "0 20px",
  boxSizing: "border-box",
  width: "100%",
  [`@media only screen and (max-width: ${theme.firstBreakpoint}px)`]: {
    top: "60px",
    alignItems: "center",
    minHeight: isListPage ? "120px" : "60px",
    paddingBottom: isListPage ? "60px" : "10px",
  },
}));

const CourseTitleAboWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isListPage'
})(({ theme, isListPage }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  height: "60px",
  position: "relative",
  width: "100%",
  [`@media only screen and (max-width: ${theme.firstBreakpoint}px)`]: {
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "start",
    paddingRight: "0px",
    maxWidth: "100%",
    height: isListPage ? "60px" : "40px",
  },
}));

const TitleUniWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minWidth: 0,
  alignSelf: "flex-start",
  [`@media only screen and (max-width: ${theme.firstBreakpoint}px)`]: {
    width: "100%",
    maxWidth: "100%",
  },
}));

const CourseTitle = styled(Box)(({ theme }) => ({
  fontWeight: "bold",
  fontSize: "38px",
  lineHeight: "52px",
  cursor: "pointer",
  width: "100%",
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  [`@media only screen and (max-width: ${theme.firstBreakpoint}px)`]: {
    fontSize: "16px",
  },
}));

const University = styled(Box)(({ theme }) => ({
  fontWeight: 500,
  fontSize: "19px",
  marginTop: "-5px",
  zIndex: -1,
  [`@media only screen and (max-width: ${theme.firstBreakpoint}px)`]: {
    fontSize: "12px",
    marginTop: "-13px",
  },
}));

export const HeaderSubSection = ({
  title,
  university,
  subscriberCount,
  loading,
  isListPage,
  isMobile,
  loadingUserData,
  goToTeachersPage,
  props,
}) => {
  if (loading || title === undefined) {
    return null;
  }

  return (
    <SubBarWrapper isListPage={isListPage}>
      {isMobile && isListPage && <CentralNavigationBar />}
      <CourseTitleAboWrapper isListPage={isListPage}>
        <TitleUniWrapper data-testid="header-course-title-wrapper">
          <CourseTitle data-testid="header-course-title" onClick={goToTeachersPage}>
            {title}
          </CourseTitle>
          <University>{university}</University>
        </TitleUniWrapper>
        {isListPage && !loadingUserData && (
          <AboComponent
            subscriberCount={subscriberCount}
            match={props?.match}
          />
        )}
      </CourseTitleAboWrapper>
    </SubBarWrapper>
  );
};
